var module = angular.module('octopusApp.projects', ['octopusApp.infrastructure', 'octopusApp.accounts', 'octopusApp.certificates']);

module.config(function($stateProvider,$urlRouterProvider, stateHelperProvider, projectStateProvider) {
    $stateProvider.state('app.projects', {
        url: '/projects',
        template: stateHelperProvider.withBreadcrumb('Projects', '#/projects'),
        layout: {
            tab: 'projects',
            title: 'Projects'
        },
        defaultSubRoute: 'app.projects.list'
    });

    $stateProvider.state('app.projects.list', {
        url: '',
        templateUrl: 'areas/projects/views/index.html',
        controller: 'ProjectIndexController'
    });

    $stateProvider.state('app.projects.new', {
        url: '/new',
        templateUrl: 'areas/projects/views/create.html',
        controller: 'ProjectEditController',
        layout: {
            title: 'New Project'
        }
    });

    $stateProvider.state('app.projects.newwithgroup', {
        url: '/new/:grpid',
        templateUrl: 'areas/projects/views/create.html',
        controller: 'ProjectEditController',
        layout: {
            title: 'New Project'
        }
    });

    $stateProvider.state('app.project', {
        url: '/projects/:projectId',
        templateUrl: 'areas/projects/views/project_layout.html',
        controller: 'ProjectLayoutController',
        resolve: {
            projectState: projectStateProvider.$get
        },
        layout: {
            title: 'View Project',
            tab: 'projects'
        },
        abstract:true
    });

    $stateProvider.state('app.project.overview', {
        url: '^/projects/:projectId?release&tenants&tags&groupBy', //Using absolute due to issues with search params, we want this state to resolve instead of abstract above
        templateUrl:  'areas/projects/views/overview.html',
        controller: 'ProjectOverviewController',
        controllerAs: 'vm',
        layout: {
            projectTab: 'overview'
        }
    });

    $stateProvider.state('app.project.settings', {
        url: '/settings',
        templateUrl:  'areas/projects/views/edit.html',
        controller: 'ProjectEditController',
        layout: {
            projectTab: 'settings'
        }
    });

    $stateProvider.state('app.project.logo', {
        url:  '/logo',
        templateUrl:  'areas/projects/views/change_logo.html',
        controller: 'ProjectLogoController',
        layout: {
            title: 'Project Logo',
            projectTab: 'settings'
        }
    });

    $stateProvider.state('app.project.process', {
        url:  '/process',
        templateUrl:  'areas/projects/views/process.html',
        controller: 'ProjectProcessController',
        layout: {
            title: 'Project Process',
            projectTab: 'process'
        }
    });

    $stateProvider.state('app.project.steptemplates', {
        url:  '/steptemplates',
        templateUrl:  'areas/projects/step-templates/step_templates.html',
        controller: 'StepTemplatesController',
        layout: {
            title: 'Step Templates',
            projectTab: 'process'
        }
    });

    $stateProvider.state('app.project.childsteptemplates', {
        url:  '/childsteptemplates/:parentStepId',
        templateUrl:  'areas/projects/step-templates/step_templates.html',
        controller: 'StepTemplatesController',
        layout: {
            title: 'Step Templates',
            projectTab: 'process'
        }
    });


    //Below repetition is PITA atm because cant seem to easily get ui-router to support multiple urls for same state
    $stateProvider.state('app.project.processnewactiontype-A', {
        url:  '/process/step/:stepId/new/:actionType',
        templateUrl:  'areas/projects/views/process_step_edit.html',
        controller: 'ProjectProcessStepEditController',
        layout: {
            title: 'Project Process Step Editor',
            projectTab: 'process'
        }
    });
    $stateProvider.state('app.project.processnewactiontype-B', {
        url:  '/process/step/:stepId/new/:actionType/:template',
        templateUrl:  'areas/projects/views/process_step_edit.html',
        controller: 'ProjectProcessStepEditController',
        layout: {
            title: 'Project Process Step Editor',
            projectTab: 'process'
        }
    });

    $stateProvider.state('app.project.processnewactiontype-C', {
        url:  '/process/step/:stepId',
        templateUrl:  'areas/projects/views/process_step_edit.html',
        controller: 'ProjectProcessStepEditController',
        layout: {
            title: 'Project Process Step Editor',
            projectTab: 'process'
        }
    });

    $stateProvider.state('app.project.processnewactiontype-D', {
        url:  '/process/step/new/:actionType',
        templateUrl:  'areas/projects/views/process_step_edit.html',
        controller: 'ProjectProcessStepEditController',
        layout: {
            title: 'Project Process Step Editor',
            projectTab: 'process'
        }
    });
    $stateProvider.state('app.project.processnewactiontype-E', {
        url:  '/process/step/new/:actionType/:template',
        templateUrl:  'areas/projects/views/process_step_edit.html',
        controller: 'ProjectProcessStepEditController',
        layout: {
            title: 'Project Process Step Editor',
            projectTab: 'process'
        }
    });

    // Releases Start
    $stateProvider.state('app.project.releases', {
        url:  '/releases',
        template: stateHelperProvider.withBreadcrumb('Releases', '#/projects/{{ project.Slug }}/releases'),
        layout: {
            projectTab: 'releases'
        },
        defaultSubRoute: 'app.project.releases.list'
    });


    $stateProvider.state('app.project.releases.list', {
        url:  '/list',
        templateUrl:  'areas/projects/views/releases.html',
        controller: 'ProjectReleasesController',
        layout: {
            title: 'Project Releases'
        }
    });

    $stateProvider.state('app.project.releases.create', {
        url:  '/create',
        templateUrl:  'areas/projects/views/release_create.html',
        controller: 'ProjectReleaseEditController',
        layout: {
            title: 'Create release'
        }
    });

    $stateProvider.state('app.project.releases.release', {
        url:  '/:version',
        template: '<ui-view></ui-view>',
        layout: {
            title: 'Release Details'
        },
        defaultSubRoute: 'app.project.releases.release.details'
    });

    $stateProvider.state('app.project.releases.release.details', {
        url:  '',
        templateUrl:  'areas/projects/views/release.html',
        controller: 'ProjectReleaseController'
    });

    $stateProvider.state('app.project.releases.release.edit', {
        url:  '/edit',
        templateUrl:  'areas/projects/views/release_edit.html',
        controller: 'ProjectReleaseEditController',
        layout: {
            title: 'Edit Details'
        }
    });

    $stateProvider.state('app.release',
        stateHelperProvider.redirectRoute('/releases/:releaseId', function($stateParams, octopusRepository){
            return octopusRepository.Releases.get($stateParams.releaseId).then(function (release) {
                return '/projects/' + release.ProjectId + '/releases/' + release.Version;
            });
        }));

    $stateProvider.state('app.project.releases.release.deployment-create-A', {
        url:  '/deployments/create',
        templateUrl: 'areas/projects/views/deployment_create.html',
        controller: 'ProjectDeploymentCreateController',
        layout: {
            title: 'Create deployment'
        }
    });

    $stateProvider.state('app.project.releases.release.deployment-create-B', {
        url:  '/deployments/create/:goal/:previousId',
        templateUrl: 'areas/projects/views/deployment_create.html',
        controller: 'ProjectDeploymentCreateController',
        layout: {
            title: 'Create deployment'
        }
    });

    $stateProvider.state('app.project.releases.release.deployment-details', {
        url:  '/deployments/:depid',
        templateUrl: 'areas/tasks/views/task.html',
        controller: 'TaskController',
        layout: {
            title: 'Deployment details'
        },
        resolve: {
            'forceProjectLoad': function(projectState) {
                if(!projectState.projectAsync) {
                    projectState.load();
                }
            }
        }
    });

    $stateProvider.state('app.deployments',
        stateHelperProvider.redirectRoute('/deployments/:deploymentId', function($stateParams, octopusRepository){
            return octopusRepository.Deployments.get($stateParams["deploymentId"]).then(function (deployment) {
                return octopusRepository.Releases.get(deployment.ReleaseId).then(function (release) {
                    return '/projects/' + release.ProjectId + '/releases/' + release.Version + '/deployments/' + deployment.Id;
                });
            });
        }));

    //Channels Start
    $stateProvider.state('app.project.channels', {
        url:  '/channels',
        template: '<script octo-section="breadcrumbs" type="text/ng-template"><li><a href="#/projects/{{ project.Slug }}/channels">Channels</a></li></script><ui-view></ui-view>',
        layout: {
            projectTab: 'channels'
        },
        defaultSubRoute: 'app.project.channels.list'
    });

    $stateProvider.state('app.project.channels.list', {
        url:  '/list',
        templateUrl:  'areas/projects/channels/channels.html',
        controller: 'ChannelsController',
        layout: {
            title: 'Project Channels'
        }
    });

    $stateProvider.state('app.project.channels.create', {
        url:  '/create',
        templateUrl:  'areas/projects/channels/channel_create.html',
        controller: 'ChannelEditController',
        layout: {
            title: 'Create Channel'
        }
    });

    $stateProvider.state('app.project.channels.edit', {
        url:  '/edit/:channelId',
        templateUrl:  'areas/projects/channels/channel_edit.html',
        controller: 'ChannelEditController',
        layout: {
            title: 'Create Channel'
        }
    });

    $stateProvider.state('app.project.triggers', {
        url:  '/triggers',
        template: stateHelperProvider.withBreadcrumb('Triggers', '#/projects/{{ project.Slug }}/triggers'),
        layout: {
            projectTab: 'triggers'
        },
        defaultSubRoute: 'app.project.triggers.list'
    });

    $stateProvider.state('app.project.triggers.list', {
        url:  '/list',
        templateUrl:  'areas/projects/triggers/triggers.html',
        controller: 'ProjectTriggersController',
        layout: {
            title: 'Project Triggers'
        }
    });

    $stateProvider.state('app.project.triggers.create', {
        url:  '/create',
        templateUrl:  'areas/projects/triggers/trigger_create.html',
        controller: 'ProjectTriggerEditController',
        layout: {
            title: 'Create Trigger'
        }
    });

    $stateProvider.state('app.project.triggers.edit', {
        url:  '/edit/:triggerId',
        templateUrl:  'areas/projects/triggers/trigger_edit.html',
        controller: 'ProjectTriggerEditController',
        layout: {
            title: 'Edit Trigger'
        }
    });

    $stateProvider.state('app.project.triggers.autoDeployReleaseOverrides', {
        url:  '/autoDeployReleaseOverrides',
        templateUrl:  'areas/projects/triggers/override_auto_deploy_release.html',
        controller: 'ProjectTriggerEditController',
        layout: {
            title: 'Edit Trigger'
        }
    });
});

module.run(function($rootScope, $state, $q, octopusRepository){

    $rootScope.$on('$stateChangeStart', function (event, toState, toParams, fromState, fromParams) {
        if (toState.name === "app.tasks.details" && !$state.current.$transitioning) {
            var taskId = toParams.taskId;
            event.preventDefault();

            octopusRepository.Tasks.get(taskId).then(function(task){
                toParams.task = task;

                if (task.Name !== 'Deploy' || !task.Arguments.DeploymentId) {
                    $state.current.$transitioning = true;
                    $state.go(toState.name, toParams);
                    $state.current.$transitioning = false;
                    return;
                }

                return octopusRepository.Deployments.get(task.Arguments.DeploymentId).then(function (deployment) {
                    return $q.all([octopusRepository.Projects.get(deployment.ProjectId),
                        octopusRepository.Releases.get(deployment.ReleaseId)])
                        .then(function(results){
                            var project = results[0];
                            var release = results[1];
                            $state.transitionTo('app.project.releases.release.deployment-details', {
                                depid: deployment.Id,
                                version: release.Version,
                                projectId: project.Slug
                            });
                        });
                });
            });
        }
    });
});


//////////////////
// WEBPACK FOOTER
// ./app/areas/projects/projects_module.js
// module id = 7969701540871223
// module chunks = 1